/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { FETCHING_USER_DETAILS, FETCHED_USER_DETAILS, FETCH_USER_DETAILS_ERROR } from '../actions/actionTypes';

const initialState = {
  user: null,
  isFetching: false,
  error: null
};

const participantDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_USER_DETAILS:
      return Object.assign({}, state, initialState, { isFetching: true });
    case FETCHED_USER_DETAILS:
      return Object.assign({}, state, initialState, { user: action.payload });
    case FETCH_USER_DETAILS_ERROR:
      return Object.assign({}, state, initialState, { error: action.payload });
    default:
      return state;
  }
};

export default participantDetailsReducer;
